module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/glyphicons-halflings-regular.woff
// module id = /I2M
// module chunks = 0